import { Icon, Modal, Text } from 'components'

import { usePostPaymentMethod } from 'shared/hooks/services/account'

import { PaymentMethodRequest } from 'services/account'

import { useToast } from 'shared/hooks'

import styles from './styles.module.scss'
import { useRef } from 'react'
import { usePutPaymentMethod } from 'shared/hooks/services/account/usePutPaymentMethod'

interface BankSlipProps {
  accountId: string
  isEditing?: boolean
}

const BankSlip = ({ accountId, isEditing = false }: BankSlipProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  const { addToast } = useToast()

  const { mutate: saveMutation } = usePostPaymentMethod()
  const { mutate: editMutation } = usePutPaymentMethod()

  const onSubmit = () => {
    const request: PaymentMethodRequest = {
      paymentMethodType: 'BANK_SLIP',
      accountId,
    }

    const mutate = isEditing ? editMutation : saveMutation

    const successMsg = `Forma de pagamento ${isEditing ? 'editada' : 'cadastrada'} com sucesso.`
    const errorMsg = `Não foi possível ${isEditing ? 'editar' : 'cadastrar'} a forma de pagamento. Tente novamente.`

    closeButtonRef?.current?.click()

    mutate(request, {
      onSuccess: () => {
        addToast({ message: successMsg, isSnackBar: true })
      },
      onError: () =>
        addToast({ message: errorMsg, type: 'alert', isSnackBar: true }),
    })
  }

  return (
    <Modal.Content className={styles.container}>
      <div className={styles.content}>
        <Icon width={48} color="element-default" name="barcode-lg" />

        <Modal.Title className={styles.title}>Pagar por boleto?</Modal.Title>

        <Text as="p" weight="regular">
          Para mais informações sobre prazos ou vencimentos, entre em contato
          com o setor administrativo.
        </Text>
      </div>

      <Modal.Footer className={styles.footer}>
        <div className={styles.actions}>
          <Modal.Close asChild>
            <button ref={closeButtonRef}>Cancelar</button>
          </Modal.Close>
          <button type="button" onClick={onSubmit}>
            Confirmar
          </button>
        </div>
      </Modal.Footer>
    </Modal.Content>
  )
}

export default BankSlip
